import { computed } from 'vue'
import store from '@/store'
import { secondsToHhMmSs } from '@/utils/index'
import { apiAutoRollbackWorkOrder } from '@/api/workPlace/workOrder'
import { clearStoreChatMsgList } from '@/utils/unReadNum'
import { REFRESH_LIST, REFRESH_MAIN } from '@/views/WorkPlace/handleEventBuss'

const storeCollect = computed(() => store.state.rollBack.roundInstance)
export class FreshRound {
  constructor(timer, countdown) {
    this.timer = timer
    this.countdown = countdown // 单位秒
    this.formatTime = ''
  }
  resetCountdown(newCountdown) {
    this.countdown = newCountdown
  }
}
export class RefreshRoundManager {
  constructor() {
    this.timer = null
  }
  startCountdown() {
    if (this.timer) {
      clearInterval(this.timer)
    }
    this.timer = setInterval(() => {
      storeCollect.value.forEach((roundItem, timer) => {
        if (roundItem.countdown > 0) {
          roundItem.countdown--
          roundItem.formatTime = secondsToHhMmSs(roundItem.countdown)
          if (roundItem.countdown === 0) {
            this.handleCountdownEnd(roundItem)
          }
        }
      })
    }, 1000)
  }
  // 处理倒计时结束的逻辑
  handleCountdownEnd(roundItem) {
    console.log(`%c====【FreshRound ${roundItem.timer} 倒计时结束！】====`, 'color:orange')
    const { timer } = roundItem
    const dealingGroupInfo = computed(() => store.state.workOrder.workOrderGroupInfo)
    const dealingWorkOrderId = computed(
      () => store.state.workOrder.workOrderGroupInfo?.targetWorkOrder?.workOrderId
    )
    // 自动变更为休息
    if (timer === 'AUTO_REST') {
      store
        .dispatch('user/shiftStatusAutoChange', {
          status: 1
        })
        .then(() => {
          store.commit('workOrder/SET_CHART_ID')
          REFRESH_LIST?.emit()
          store.dispatch('user/getUserInfo')
          store.commit('initChatState')
          clearStoreChatMsgList()
        })
        .catch(() => {
          store.dispatch('user/queryShiftStaus')
        })
    }
    // 回滚工单
    if (typeof timer === 'number') {
      apiAutoRollbackWorkOrder({ workOrderId: timer }).then(res => {
        const { changeFlag, changeTime } = res
        store.commit('rollBack/SET_ROUND_INSTANCE', {
          timer: timer,
          callBackTime: !changeFlag ? changeTime : null
        })
        if (changeFlag) {
          if (!dealingWorkOrderId.value || Number(dealingWorkOrderId.value) === timer) {
            REFRESH_MAIN?.emit()
            REFRESH_LIST?.emit()
          } else if (
            dealingWorkOrderId.value !== timer &&
            dealingGroupInfo.value.dealWorkOrderList.some(
              item => Number(item.workOrderId) === timer
            )
          ) {
            REFRESH_MAIN?.emit()
          } else {
            REFRESH_LIST?.emit()
          }
          store.dispatch('rollBack/getAllRefreshTimer')
        }
      })
    }
  }
  stopCountdown() {
    clearInterval(this.timer)
  }
  resetAllCountdowns(newCountdown) {
    storeCollect.value.forEach(roundItem => {
      roundItem.resetCountdown(newCountdown)
    })
  }
}
